import {
    MuiTheme, fontFamilyMontserrat
} from 'assets/theme';

const HomePageSharedStyle = {
    titleText: {
        ...fontFamilyMontserrat,
        fontSize: '2.3rem',
        fontWeight: '500',
        color: MuiTheme.palette.common.black
    }
}

export default HomePageSharedStyle;
